(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gallery]').forEach(function (g) {
  var main = g.querySelector('#km-pdp-main');
  var stage = g.querySelector('[data-stage]');
  var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
  if (!main) return;
  var index = 0;

  var zoomActive = false;

  function show(i) {
    if (!thumbs.length) return;
    index = (i + thumbs.length) % thumbs.length;
    var url = thumbs[index].getAttribute('data-thumb');
    main.removeAttribute('srcset');   // srcset würde sonst src überschreiben
    main.removeAttribute('sizes');
    main.src = url;
    zoomActive = false;               // Bildwechsel beendet Zoom-Modus
    stage.classList.remove('is-zoom-active');
    main.style.transform = '';
    main.style.transformOrigin = 'center';
    // Zustand auch fuer Hilfsmittel mitfuehren (WCAG 4.1.2).
    thumbs.forEach(function (x) { x.classList.remove('is-active'); x.removeAttribute('aria-current'); });
    thumbs[index].classList.add('is-active');
    thumbs[index].setAttribute('aria-current', 'true');
    thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

  var prev = g.querySelector('[data-gallery-prev]');
  var next = g.querySelector('[data-gallery-next]');
  if (prev) prev.addEventListener('click', function () { show(index - 1); });
  if (next) next.addEventListener('click', function () { show(index + 1); });

  if (!stage) return;
  var multi = thumbs.length > 1;
  stage.classList.add('is-zoomable');

  // Tastatur (Pfeile) wenn Galerie fokussiert
  if (multi) {
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });
  }

  main.addEventListener('dragstart', function (e) { e.preventDefault(); });

  var dragging = false, moved = false, downX = 0, downY = 0;
  var ZOOM = 2.4;

  function panZoom(clientX, clientY) {
    var r = stage.getBoundingClientRect();
    var x = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
    var y = Math.max(0, Math.min(100, ((clientY - r.top) / r.height) * 100));
    main.style.transition = 'none';
    main.style.transformOrigin = x + '% ' + y + '%';
    main.style.transform = 'scale(' + ZOOM + ')';
  }

  // Zoom AN/AUS per Klick auf das „+“-Icon (kein Hover-Zoom)
  var zoomIco = g.querySelector('[data-zoom-toggle]');
  if (zoomIco) {
    zoomIco.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    zoomIco.addEventListener('click', function (e) {
      e.stopPropagation();
      zoomActive = !zoomActive;
      stage.classList.toggle('is-zoom-active', zoomActive);
      main.style.transition = 'transform .15s ease';
      main.style.transformOrigin = 'center';
      main.style.transform = zoomActive ? 'scale(' + ZOOM + ')' : '';
    });
  }

  // Ziehen (Maus + Touch) → Bild wechseln (nur wenn Zoom aus)
  stage.addEventListener('pointerdown', function (e) {
    // Auf den Bedienelementen KEIN Ziehen starten: sonst faengt die Buehne den
    // Zeiger per Pointer-Capture ein, das click-Ereignis entsteht dann an der
    // Buehne statt am Knopf - und die Pfeile reagieren nicht mehr.
    if (e.target.closest('[data-gallery-prev],[data-gallery-next],[data-zoom-toggle]')) return;
    if (zoomActive) return;
    if (e.button && e.button !== 0) return;
    dragging = true; moved = false; downX = e.clientX; downY = e.clientY;
    stage.classList.add('is-dragging');
    main.style.transition = 'none';
    main.style.transform = 'translateX(0px)';
    main.style.transformOrigin = 'center';
    try { stage.setPointerCapture(e.pointerId); } catch (_) {}
  });

  stage.addEventListener('pointermove', function (e) {
    if (zoomActive) { panZoom(e.clientX, e.clientY); return; }
    if (!dragging) return;
    var dx = e.clientX - downX, dy = e.clientY - downY;
    if (!moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) moved = true;
    if (moved && multi) { e.preventDefault(); main.style.transform = 'translateX(' + dx + 'px)'; }
  });

  function endDrag(e) {
    if (!dragging) return;
    dragging = false;
    stage.classList.remove('is-dragging');
    try { stage.releasePointerCapture(e.pointerId); } catch (_) {}
    var dx = e.clientX - downX;
    if (multi && Math.abs(dx) > 40) {
      main.style.transition = 'none';
      show(dx < 0 ? index + 1 : index - 1);
    } else {
      main.style.transition = 'transform .18s ease';
      main.style.transform = '';
    }
  }
  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);
});
(function () {
  var form = document.getElementById('km-product-form');
  if (!form) return;
  var qty = form.querySelector('[data-qty]');
  var priceEl = document.querySelector('[data-price]');
  var kgEl = document.querySelector('[data-kg-display]');
  var qtyTierWrap = form.querySelector('[data-qtytiers]');

  // Menge ↔ Staffel: passende Stufe aktivieren & Einzelpreis + €/kg oben aktualisieren
  function syncQtyTiers() {
    if (!qtyTierWrap || !qty) return;
    var q = parseInt(qty.value || '1', 10);
    if (isNaN(q) || q < 1) q = 1;
    var best = null, bestMin = 0;
    qtyTierWrap.querySelectorAll('[data-qty-tier]').forEach(function (btn) {
      var min = parseInt(btn.getAttribute('data-qty-tier') || '1', 10);
      if (q >= min && min >= bestMin) { best = btn; bestMin = min; }
    });
    // aria-pressed nur an den Staffel-Schaltflaechen; die Varianten-Auswahl
    // weiter unten sind echte Radio-Felder und melden ihren Zustand selbst.
    qtyTierWrap.querySelectorAll('.km-pdp__tier').forEach(function (t) {
      t.classList.remove('is-active');
      if (t.hasAttribute('aria-pressed')) t.setAttribute('aria-pressed', 'false');
    });
    if (best) {
      best.classList.add('is-active');
      if (best.hasAttribute('aria-pressed')) best.setAttribute('aria-pressed', 'true');
      var up = best.getAttribute('data-unit-price');
      if (priceEl && up) priceEl.textContent = up;
      var ukg = best.getAttribute('data-tier-kg');
      if (kgEl && ukg) kgEl.textContent = ukg;
    }
  }

  form.querySelector('[data-qty-dec]') && form.querySelector('[data-qty-dec]').addEventListener('click', function () {
    qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1);
    syncQtyTiers();
  });
  form.querySelector('[data-qty-inc]') && form.querySelector('[data-qty-inc]').addEventListener('click', function () {
    qty.value = parseInt(qty.value || '1', 10) + 1;
    syncQtyTiers();
  });
  if (qty) {
    qty.addEventListener('input', syncQtyTiers);
    qty.addEventListener('change', syncQtyTiers);
  }

  form.querySelectorAll('[data-tier]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      form.querySelectorAll('.km-pdp__tier').forEach(function (t) { t.classList.remove('is-active'); });
      var label = radio.closest('.km-pdp__tier');
      if (label) label.classList.add('is-active');
      if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
    });
  });
  form.querySelectorAll('[data-qty-tier]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (qty) qty.value = btn.getAttribute('data-qty-tier');
      syncQtyTiers();
    });
  });
  var aboToggle = form.querySelector('[data-abo-toggle]');
  var aboField = form.querySelector('[data-abo-field]');
  var aboIntervals = form.querySelector('[data-abo-intervals]');
  if (aboToggle && aboField) {
    aboToggle.addEventListener('change', function () {
      aboField.disabled = !aboToggle.checked;
      if (aboIntervals) aboIntervals.hidden = !aboToggle.checked;
    });
    form.querySelectorAll('[data-abo-interval]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.querySelectorAll('[data-abo-interval]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        aboField.value = btn.getAttribute('data-abo-interval');
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
